import { routes } from "consts";
import React from "react";
import { useNavigate } from "react-router-dom";
import { HeaderWithBreadcrumbs } from "components/molecules/HeaderWithBreadcrumbs/HeaderWithBreadbrumbs";
import { PageMain } from "components/molecules";
import { getApiErrorMessage, useToaster } from "utils";
import { useQueryClient } from "@tanstack/react-query";
import { CategoryForm, CategoryFormValues } from "./CategoryForm/CategoryForm";
import { categoriesApi } from "api/categories";
import { QUERIES_KEYS } from "queries";

export const CategoryAddPage = (): JSX.Element | null => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { showSuccess, showError } = useToaster();

  const onSubmit = async (data: CategoryFormValues) => {
    try {
      await categoriesApi.create(data);
      queryClient.invalidateQueries({ queryKey: QUERIES_KEYS.CATEGORIES });
      queryClient.invalidateQueries({ queryKey: QUERIES_KEYS.CATEGORY_TREE });
      navigate(routes.COURSES_CATEGORIES);
      showSuccess("Kategoria została dodana");
    } catch (error) {
      console.error(error);
      showError(getApiErrorMessage(error, "Wystąpił błąd podczas dodawania kategorii"));
    }
  };

  return (
    <PageMain>
      <HeaderWithBreadcrumbs
        breadcrumbs={[{ title: "Kategorie", path: routes.COURSES_CATEGORIES }, { title: "Tworzenie nowej kategorii" }]}
        headerText="Dodaj nową kategorię"
      />

      <CategoryForm onSubmit={onSubmit} />
    </PageMain>
  );
};
